export const NATURAL = { ID:1, CODIGO: 'N' };
export const JURIFICA = { ID:2, CODIGO: 'J' };
export const NO_DOMICILIADO = { ID:3, CODIGO: 'ND' };